import React from 'react';
import { FormSpy } from 'react-final-form';
import FloatingSaveBar from '~/components/molecule/FloatingSaveBar';

type Props = { disableSave?: boolean };

const LegacySaveBar: React.FCC<Props> = ({ disableSave }) => (
  <FormSpy>
    {({ form }) => {
      const formState = form.getState();
      const dirtyFields: $Object | null | undefined = formState.dirtyFields;
      const numberOfChanges = dirtyFields ? Object.keys(dirtyFields).length : 0;

      if (numberOfChanges === 0) return null;

      return (
        <FloatingSaveBar
          visible={numberOfChanges !== 0}
          actionProps={{
            onSave: () => {
              void form.submit();
            },
            onCancel: () => {
              // https://github.com/final-form/final-form/issues/151
              form.setConfig('keepDirtyOnReinitialize', false);
              form.reset();
              form.setConfig('keepDirtyOnReinitialize', true);
            },
            disabled: !!formState.submitting || !!disableSave,
            loading: !!formState.submitting,
          }}
          numberOfChanges={numberOfChanges}
        />
      );
    }}
  </FormSpy>
);

export default LegacySaveBar;
